export const DOC_CAPTURE_MANUAL_CAMERA_EXPERIMENT = "doc_capture_manual_camera";
export const DOC_CAPTURE_EXPERIMENT_CONTROL = "control";
export const DOC_CAPTURE_EXPERIMENT_VARIATION = "variation";
export const DOC_CAPTURE_SUCCESS_EVENT = "doc_capture_success";
export const DOC_CAPTURE_LOCAL_DECODE_EXPERIMENT = "doc_capture_local_decode";
export const DOC_CAPTURE_LOCAL_DECODE_SUCCESS_EVENT = "doc_capture_local_decode_success";
export const DOC_CAPTURE_PAGE_LANDED_EVENT = "doc_capture_page_landed";



// WEBPACK FOOTER //
// ./src/constants/Experiments.ts